<template>
  <b-card v-if="labs.length > 0" class="mb-3" no-body>
    <b-card-header class="py-2 bg-light d-flex justify-content-between align-items-center">
      <span><i class="fas fa-flask mr-2"></i>งานแลป</span>
      <b-badge variant="warning">{{ labs.length }}</b-badge>
    </b-card-header>
    <b-card-body class="p-0">
      <b-table
        :items="labs"
        :fields="fields"
        :tbody-tr-class="rowClass"
        table-class="table-condensed"
        small
        hover
        responsive
        head-variant="light"
        class="mb-0"
      >
        <template #cell(name)="{ item }">
          {{ item.mLab?.nameTh || item.mLab?.nameEn || '-' }}
        </template>
        <template #cell(toothNo)="{ item }">
          {{ item.toothNo || '-' }}
        </template>
        <template #cell(status)="{ item }">
          <div v-if="item.isUpdating" class="text-center">
            <b-spinner small></b-spinner>
          </div>
          <b-dropdown
            v-else
            size="xs"
            :text="getStatusLabel(item.status)"
            :variant="getStatusVariant(item.status)"
            boundary="window"
          >
            <b-dropdown-item
              v-for="s in statusList"
              :key="s.value"
              @click="onStatusChange(item, s.value)"
            >{{ s.label }}</b-dropdown-item>
          </b-dropdown>
        </template>
        <template #cell(creationDt)="{ item }">
          {{ formatDate(item.creationDt) }}
        </template>
      </b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapActions } from "vuex";
import { LAB_STATUS_LIST, getLabStatusByValue } from "@/constants/labStatus";
import moment from "moment";

export default {
  name: "LabLinkCard",
  props: {
    labs: { type: Array, default: () => [] }
  },
  data() {
    return {
      statusList: LAB_STATUS_LIST,
      fields: [
        { key: "name", label: "รายการแลป", class: "narrow-spacing" },
        { key: "toothNo", label: "ซี่ฟัน", class: "narrow-spacing d-none d-md-table-cell" },
        { key: "status", label: "สถานะ", class: "narrow-spacing" },
        { key: "creationDt", label: "วันที่สร้าง", class: "narrow-spacing d-none d-lg-table-cell" }
      ]
    };
  },
  methods: {
    ...mapActions({
      updateLabStatus: "moduleLab/updateLabStatus"
    }),
    formatDate(date) {
      return date ? moment(date).format("DD MMM YY") : "-";
    },
    getStatusLabel(status) {
      return getLabStatusByValue(status).label;
    },
    getStatusVariant(status) {
      return getLabStatusByValue(status).variant;
    },
    rowClass(item) {
      return item.status === 'Delivered' ? 'delivered-lab' : '';
    },
    async onStatusChange(lab, newStatus) {
      this.$set(lab, "isUpdating", true);
      try {
        await this.updateLabStatus({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          labId: lab.id,
          status: newStatus
        });
        lab.status = newStatus;
        // Update modifyDt locally so the item stays visible within 30-day filter
        lab.modifyDt = new Date().toISOString();
        this.$emit("statusUpdated", lab);
      } catch (err) {
        console.error("Failed to update lab status:", err);
      } finally {
        this.$set(lab, "isUpdating", false);
      }
    }
  }
};
</script>

<style>
.table-condensed {
  font-size: 0.8rem;
}
.table .delivered-lab {
  opacity: 0.6 !important;
  background-color: #f8f9fa !important;
}
.table .delivered-lab td {
  color: #6c757d !important;
}
.btn-purple {
  background-color: #6f42c1;
  border-color: #6f42c1;
  color: #fff;
}
.btn-purple:hover,
.btn-purple:focus {
  background-color: #5a32a3;
  border-color: #5a32a3;
  color: #fff;
}
</style>
